import React from 'react';
import { View } from 'react-native';
import { ThemedView, ThemedText } from '@app/theme';

const LoanTenureTooltip: React.FC<any> = ({ onClose, duration }) => (
  <ThemedView
    position="absolute"
    top={26}
    right={-20}
    backgroundColor="white"
    padding={"md"}
    borderColor={"border-primary"}
    borderWidth={1}
    borderRadius={"sm"}
    zIndex={9999}
    width={250}
    shadowOffset={{ width: 0, height: 0 }}
    shadowOpacity={1}
    shadowRadius={17}
    elevation={10}
    style={{
      shadowColor: 'rgba(0, 0, 0, 0.17)',
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 1,
      shadowRadius: 17,
      backgroundColor: 'white',
    }}
  >
    <ThemedText variant="b5r" color="text-primary" numberOfLines={1}>
      • Tenure of credit line facility is {duration} months
    </ThemedText>
    <ThemedView flexDirection={"row"}>
      <ThemedText variant="b5r" color="text-primary">
        •
      </ThemedText>
      <ThemedText variant="b5r" color="text-primary" ml={"xs"}>
        Renewal can be done easily without repaying principal
      </ThemedText>
    </ThemedView>
    <View style={{
      position: 'absolute',
      top: -8,
      right: 20,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderTopWidth: 0,
      borderRightWidth: 8,
      borderBottomWidth: 8,
      borderLeftWidth: 8,
      borderTopColor: 'transparent',
      borderRightColor: 'transparent',
      borderBottomColor: 'white',
      borderLeftColor: 'transparent',
      elevation: 10,
    }} />

  </ThemedView>
);

export default LoanTenureTooltip; 